import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectIsBtMasterOnly } from '../../../account-info-header/reducers';
import { Subject, takeUntil } from 'rxjs';
import { Constants } from '../../../shared/utilities/Constants';

@Component({
  standalone: false,
  selector: 'mm-view-move-money-page',
  templateUrl: './view-move-money-page.component.html',
  styleUrls: ['./view-move-money-page.component.scss'],
})
export class ViewMoveMoneyPageComponent implements OnInit {
  isBtMasterOnly: boolean = false
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private store: Store) { }

  ngOnInit(): void {
    this.store.select(selectIsBtMasterOnly).pipe(takeUntil(this.destroy$)).subscribe((val) => {
      this.isBtMasterOnly = val;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  get mainMessageText(): string {
    if (this.isBtMasterOnly) {
      return Constants.blockTradingAccountPrimary;
    }
    return Constants.missingViewMoveMoneyPrimary;
  }

  get secondaryMessageText(): string {
    if (this.isBtMasterOnly) {
      return Constants.blockTradingAccountSecondary;
    }
    return Constants.missingViewMoveMoneySecondary;
  }
}